import React from "react";
import BaseCard, { BaseCardListItem } from "components/BaseCard";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { NavigationProp, useNavigation } from "@react-navigation/native";
import { AccountStackParamList } from "navigation/types";
import i18n from "plugins/localization";

const AddNewMemberCard = () => {
  const navigation = useNavigation<NavigationProp<AccountStackParamList>>();
  return (
    <BaseCard title={i18n.t("screens.ManageSubscriptions.newMembers")}>
      <BaseCardListItem
        title={i18n.t("screens.ManageSubscriptions.addNewMember")}
        accessoryLeft={
          <MaterialCommunityIcons
            name="account-plus-outline"
            size={24}
            color="black"
          />
        }
        onPress={() => navigation.navigate("AddMembership")}
      ></BaseCardListItem>
    </BaseCard>
  );
};

export default AddNewMemberCard;
